export default __webpack_public_path__ + "static/media/Vermiculated Fang of all Fiends.99bdc7ba.jpg";